import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	type SelectChangeEvent,
} from "@mui/material";
import { usePassShapesLookup } from "../hooks/usePassIds";

interface PassShapeSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	required?: boolean;
	size?: "small" | "medium";
	disabled?: boolean;
	includeAll?: boolean;
}

export const PassShapeSelector = ({
	value,
	onChange,
	label = "Pass Shape",
	fullWidth = false,
	required = false,
	size = "small",
	disabled = false,
	includeAll = false,
}: PassShapeSelectorProps) => {
	const { data: passShapes = [], isLoading } = usePassShapesLookup();

	const handleChange = (event: SelectChangeEvent<number | "">) => {
		const val = event.target.value;
		onChange(val === "" ? null : (val as number));
	};

	return (
		<FormControl
			fullWidth={fullWidth}
			size={size}
			required={required}
			sx={{ minWidth: 150 }}
		>
			<InputLabel>{label}</InputLabel>
			<Select
				value={value ?? ""}
				onChange={handleChange}
				label={label}
				disabled={disabled || isLoading}
			>
				{includeAll && (
					<MenuItem value="">
						<em>All</em>
					</MenuItem>
				)}
				{passShapes.map((ps) => (
					<MenuItem key={ps.Id} value={ps.Id}>
						{ps.Name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
